/* eslint-disable max-len */
const presets = {
  rectangle: {
    name: 'rectangle',
    icon: '▭',
    description: '',
    value: 'polygon(20% 0 20% 0)',
    values: [
      {
        coords: [[10, 10], [90, 10], [90, 90], [10, 90]],
        type: 'polygon',
      },
    ],
  },
  square: {
    name: 'square',
    icon: '□',
    description: '',
    value: 'polygon(0 0 0 0)',
    values: [
      {
        coords: [[10, 10], [90, 10], [90, 90], [10, 90]],
        type: 'polygon',
      },
    ],
  },
  triangle: {
    name: 'triangle',
    icon: '△',
    description: '',
    value: 'polygon(50% 0%, 0% 100%, 100% 100%)',
    values: [
      {
        coords: [[50, 0], [0, 100], [100, 100]],
        type: 'polygon',
      },
    ],
  },
  ellipse: {
    name: 'ellipse',
    icon: '⬭',
    description: '',
    value: 'ellipse(25% 50% at 50% 50%)',
    values: [
      {
        coords: [[50, 50], [50, 5], [75, 50]],
        type: 'ellipse',
      },
    ],
  },
  circle: {
    name: 'circle',
    icon: '○',
    description: '',
    value: 'ellipse(50% 50% at 50% 50%)',
    values: [],
  },
  star: {
    name: 'star',
    icon: '☆',
    description: '',
    value: 'polygon(50% 2.45%, 61.8% 38.77%, 100% 38.77%, 69.1% 61.23%, 80.9% 97.55%, 50% 75.1%, 19.1% 97.55%, 30.9% 61.23%, 0% 38.77%, 38.2% 38.77%)',
    values: [
      {
        coords: [[50, 0], [61, 35], [98, 35], [68, 57], [79, 91], [50, 70], [21, 91], [32, 57], [2, 35], [39, 35]],
        type: 'polygon',
      },
    ],
  },
}

export default presets
